export const searchAlertRespondersPageSize = 1000;
export const externalRecipientsCopyPageSize = 100;
